document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.popup-trigger');
    const popupContainer = document.createElement('div'); // Popup container
    popupContainer.id = 'popup';
    popupContainer.innerHTML = `<div id="popup-content"></div>`;
    document.body.appendChild(popupContainer);

    const popupContent = document.getElementById('popup-content');

    // trigger popup window
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const popupId = this.getAttribute('data-popup-id'); // get popup ID
            const popupTemplate = document.getElementById(popupId);

            if (popupTemplate) {
                popupContent.innerHTML = popupTemplate.innerHTML; // insert content
                popupContainer.style.display = 'flex'; // display popup

                // 
                const closeBtn = popupContent.querySelector('.close-btn');
                closeBtn.addEventListener('click', function () {
                    popupContainer.style.display = 'none'; 
                    popupContent.innerHTML = ''; 
                });
            }
        });
    });

    // click to close popup window
    popupContainer.addEventListener('click', function (event) {
        if (event.target === popupContainer) {
            popupContainer.style.display = 'none';
            popupContent.innerHTML = '';
        }
    });

    // jump button function
    const jumpBtns = document.querySelectorAll('.jump-botton');
    jumpBtns.forEach(jumpBtn => {
        jumpBtn.addEventListener('click', function () {
            var element1 = document.getElementById("description-1");
            element1.classList.add("hide");
            var element2 = document.getElementById("description-2");
            element2.classList.remove("hide");
            var element3 = document.getElementById("tab-description-1");
            element3.classList.remove("first");
            element3.classList.remove("ignore");
            element3.removeAttribute("aria-selected");
            var element4 = document.getElementById("tab-description-2");
            element4.setAttribute("aria-selected", "true");
            element4.classList.add("first");
            element4.classList.add("ignore");
        });
    });

    // jump button function 2
    const jumpBtns2 = document.querySelectorAll('.jump-botton-2');
    jumpBtns2.forEach(jumpBtn2 => {
        jumpBtn2.addEventListener('click', function () {
            var element1 = document.getElementById("description-1");
            element1.classList.add("hide");
            var element2 = document.getElementById("description-2");
            element2.classList.add("hide");
            var element3 = document.getElementById("description-3");
            element3.classList.remove("hide");
            var element4 = document.getElementById("tab-description-1");
            element4.classList.remove("first");
            element4.classList.remove("ignore");
            element4.removeAttribute("aria-selected");
            var element5 = document.getElementById("tab-description-2");
            element5.classList.remove("first");
            element5.classList.remove("ignore");
            element5.removeAttribute("aria-selected");
            var element6 = document.getElementById("tab-description-3");
            element6.setAttribute("aria-selected", "true");
            element6.classList.add("first");
            element6.classList.add("ignore");
        });
    });

    // strip light calculator function
    const calBtn = document.getElementById("calculate-button");
    const container = document.getElementById("result");
    calBtn.addEventListener("click", function () {
        const projectLength = parseFloat(document.getElementById("project_length").value);
        const powerConsumption = parseFloat(document.getElementById("power_consumption").value);
        const environment = parseFloat(document.getElementById("environment-select").value);
        let totalAmount = 0;
        totalAmount = projectLength * powerConsumption * environment;
        console.log(totalAmount);			
        if (Number.isNaN(totalAmount)) {
        	suggest.setAttribute('value', "Check Input Values!!!");
        } else {
			suggest.setAttribute('value', `${Math.ceil(totalAmount)}W`);
        }
    });

    
});


